var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 66,
    viewBox: "0 0 82 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.68C6 16.1915 6 13.4472 7.06814 11.3509C8.0077 9.5069 9.5069 8.0077 11.3509 7.06814C13.4472 6 16.1915 6 21.68 6H60.32C65.8085 6 68.5528 6 70.6491 7.06814C72.4931 8.0077 73.9923 9.5069 74.9319 11.3509C76 13.4472 76 16.1915 76 21.68V44.32C76 49.8085 76 52.5528 74.9319 54.6491C73.9923 56.4931 72.4931 57.9923 70.6491 58.9319C68.5528 60 65.8085 60 60.32 60H21.68C16.1915 60 13.4472 60 11.3509 58.9319C9.5069 57.9923 8.0077 56.4931 7.06814 54.6491C6 52.5528 6 49.8085 6 44.32V21.68Z",
    fill: "#00CD9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9052 29.4219H52.5888V43.5806C52.5888 44.6851 51.6933 45.5805 50.5888 45.5805H31.9052C30.8007 45.5805 29.9052 44.6851 29.9052 43.5805V29.4219Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9052 31.3663H52.5888V35.3827H29.9052V31.3663Z",
    fill: "#00CD9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5843 18.9356C32.5843 19.8676 33.3398 20.6231 34.2718 20.6231H35.2103C36.1423 20.6231 36.8978 19.8676 36.8978 18.9356V18.1875C36.8978 17.2556 37.6533 16.5 38.5853 16.5H44.0589C44.9909 16.5 45.7464 17.2556 45.7464 18.1875V18.9356C45.7464 19.8676 46.5019 20.6231 47.4339 20.6231H48.3734C49.3053 20.6231 50.0609 19.8676 50.0609 18.9356V18.1875C50.0609 17.2556 50.8164 16.5 51.7484 16.5H54.5208C55.4528 16.5 56.2083 17.2556 56.2083 18.1875V29.6797C56.2083 30.6117 55.4528 31.3672 54.5208 31.3672H28.3294C27.3974 31.3672 26.6419 30.6117 26.6419 29.6797V18.1875C26.6419 17.2556 27.3974 16.5 28.3294 16.5H30.8968C31.8288 16.5 32.5843 17.2556 32.5843 18.1875V18.9356Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChess);
export default __webpack_public_path__ + "static/media/chess.b33ba7828bb085a7d006b97dacc49c27.svg";
export { ForwardRef as ReactComponent };